export const entByCountry = (builder) => ({
    entByCountry: builder.mutation({
      query: ({ page, limit, search, country}) => {
        const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
        return {
          url: `/enterprises/location/${country}`,
          method: 'GET',
          params: { page, limit, search },
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          },
        };
      },
    }),
  });
  